export default __webpack_public_path__ + "static/media/apt_placeholder.b8d93b2c.png";